import React from 'react';
const links = [{
  label: 'Build your X1',
  href: '#build-your-x1'
}, {
  label: 'Lens system',
  href: '#lenses'
}, {
  label: 'How to use',
  href: '#guide'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Track order',
  href: '/track'
}];
export function SiteNav() {
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-ink-950/95 backdrop-blur" data-id="element-1276" data-mp="35ofpskytf6lc">
      <nav aria-label="Main" className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-2 sm:px-6 lg:px-8 lg:py-3" data-id="element-1277" data-mp="31mb3666sba87">
        <a href="#top" className="shrink-0" data-id="element-1278" data-mp="2wm6licu549ge">
          <span className="block font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-offwhite sm:text-3xl" data-id="element-1279" data-mp="2rnv9pwkabovj">
            Grit<span className="text-grit-500" data-id="element-1280" data-mp="2mqv5lr6zww72">Vue</span>
            <sup className="ml-0.5 align-super text-[9px] text-steel-400" data-id="element-1281" data-mp="pxjuah02y60q">™</sup>
          </span>
          <span className="mt-0.5 hidden text-[9px] font-semibold uppercase tracking-[0.3em] text-steel-400 sm:block" data-id="element-1282" data-mp="kxfbulfm317v">
            See the job through
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-1283" data-mp="dyp4vbn7udpn">
          {links.map(link => <li key={link.href} data-id="element-1284" data-mp="dwch2hus194o">
              <a href={link.href} className="text-xs font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1285" data-mp="3v7lwhs4pzpy6">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href="#build-your-x1" className="inline-flex shrink-0 items-center whitespace-nowrap bg-grit-500 px-3 py-2 font-display text-base font-extrabold uppercase leading-none tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:px-4 sm:text-lg" data-id="element-1286" data-mp="wpgduc3ak23i">
          Build your X1<span className="hidden sm:inline" data-id="element-1287" data-mp="1ffejkljm9j3z">&nbsp;— from $29.95</span>
        </a>
      </nav>

      <ul aria-label="Sections" className="flex gap-5 overflow-x-auto border-t border-white/10 px-4 py-1.5 [-ms-overflow-style:none] [scrollbar-width:none] lg:hidden [&::-webkit-scrollbar]:hidden" data-id="element-1288" data-mp="1pbeogz6w6j70">
        {links.map(link => <li key={link.href} data-id="element-1289" data-mp="1g9f725rytd3j">
            <a href={link.href} className="whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1290" data-mp="1gct737d5pa7t">
              {link.label}
            </a>
          </li>)}
      </ul>
    </header>;
}